export const ja = {
  common: {
    generating: '生成中...',
    analyzing: '分析中...',
    copy: 'コピー',
    copied: 'コピーしました！',
    copyAll: '全てコピー',
    close: '閉じる',
    retry: '再試行',
    clear: 'クリア',
    cancel: 'キャンセル',
    save: '保存',
    saved: '保存済み',
    delete: '削除',
    reset: 'リセット',
    loading: '読み込み中...',
    score: 'スコア',
    add: '追加',
    clickToCopy: 'クリックでコピー',
    savedToIdeas: 'アイデアに保存しました！',
    savedToDrafts: '下書きに保存しました！',
    chars: '文字',
    deleteConfirm: 'この項目を削除しますか？',
    deleteAllConfirm: '本当に全て削除しますか？この操作は取り消せません。',
    noExportData: 'エクスポートするデータがありません。',
    done: '完了',
    edit: '編集',
    ok: 'OK',
    confirm: '確認',
    or: 'または',
    postToX: 'Xに投稿',
    postedToX: 'Xに投稿しました',
    processing: '処理中...',
    show: '表示',
    hide: '隠す',
    error: 'エラーが発生しました。もう一度お試しください。',
  },

  sidebar: {
    title: 'Bangerfy',
    subtitle: 'Turn your voice into bangers',
    sections: {
      create: '作成',
      analyze: '分析',
      grow: '成長',
    },
    nav: {
      brainDump: 'Brain Dump',
      brainDumpSub: '思いつきを書き出す',
      composeIdeas: 'アイデア構成',
      composeIdeasSub: 'ブロックから組み立て',
      contentCoach: 'コンテンツコーチ',
      contentCoachSub: 'フィードバックを得る',
      algoAnalyzer: 'アルゴ分析',
      algoAnalyzerSub: '投稿をスコアリング',
      replyGuy: 'リプライガイ',
      replyGuySub: 'リプライを作成',
      inspiration: 'インスピレーション',
      inspirationSub: 'アイデアを探す',
      accountResearcher: 'アカウント分析',
      accountResearcherSub: 'パターンを学ぶ',
      history: '履歴',
      historySub: '過去の結果',
      education: '学習',
      educationSub: '使い方を学ぶ',
      drafts: '下書き',
      draftsSub: '保存した下書き',
      analytics: 'アナリティクス',
      analyticsSub: '統計情報',
      settings: '設定',
      settingsSub: '各種設定',
      admin: '管理',
      adminSub: 'システム',
      more: 'もっと',
    },
    footer: '© 2026 Bangerfy',
  },

  login: {
    badge: 'AI搭載のツイート作成ツール',
    heroLine1: '刺さるツイートを、',
    heroLine2: '毎回、確実に。',
    heroSub: 'あなたの投稿を学び、コンテンツをスコアリングし、自信を持って投稿できる9つのAIツール。Xのためのゴーストライター。',
    getStarted: '無料で始める',
    skipToSetup: 'セットアップへ',
    social: {
      creators: 'クリエイター',
      tweets: 'ツイート生成数',
      hours: '節約時間',
    },
    tools: {
      brain: { label: 'Brain Dump', desc: '生の思考をダンプして、ツイート用コンテンツに変換。AIがあなたの意識の流れをバズるポストに。' },
      compose: { label: 'Compose Ideas', desc: 'アイデアブロックからツイートを構築。コンセプトを組み合わせてスコア付きバリエーションを生成。' },
      coach: { label: 'Content Coach', desc: 'フックの強さ、明瞭さ、エンゲージメント、CTAの効果をリアルタイムでフィードバック。' },
      reply: { label: 'Reply Guy', desc: '共感・ウィット・専門家・カジュアル — あらゆるトーンで完璧なリプライを作成。' },
      analytics: { label: 'Analytics', desc: '投稿パターンを深掘り。最適な時間帯、トピック、エンゲージメントトリガーを発見。' },
      algo: { label: 'Algo Analyzer', desc: '投稿前に8つのアルゴリズム指標でスコアリング。' },
      researcher: { label: 'Account Researcher', desc: 'アカウントの成功パターンを分析 — トーン、トピック、エンゲージメントトリガー。' },
      inspiration: { label: 'Inspiration', desc: 'トレンドトピックを見つけて、キーワードから新鮮なツイートアイデアを生成。' },
      education: { label: 'Education', desc: 'Xのアルゴリズム、コンテンツ戦略、成長戦術をガイド付きレッスンで学ぶ。' },
    },
    features: {
      sectionLabel: 'ツール',
      sectionTitle: '9つのツール。1つのワークフロー。',
      sectionDesc: 'X上での作成・分析・成長に必要なすべて — あなたのスタイルを学ぶAIが搭載。',
      voiceTitle: '音声ファースト',
      voiceDesc: '思いつきを話すだけ。Brain Dumpから洗練されたツイートへ、ワンタップで。',
      styleTitle: 'スタイル学習',
      styleDesc: 'AIが過去のツイートを分析し、あなたらしい文体を完璧に再現。',
      viralTitle: 'バイラルスコア',
      viralDesc: '投稿前に8つのアルゴリズム指標でスコアリング。',
    },
    howItWorks: '使い方',
    howTitle: '思いつきからツイートまで60秒',
    howStep1Title: 'アップロード',
    howStep2Title: '生成',
    howStep3Title: '投稿',
    step1: '過去のツイートをアップロード、またはゼロから開始。AIがあなた独自の声とパターンを学習。',
    step2: 'AIがあなたのスタイルで複数のバリエーションを生成、8つのバイラル指標でスコアリング。',
    step3: 'ベストを選んで、必要なら調整して、自信を持って投稿。',
    pricing: {
      sectionLabel: '料金',
      sectionTitle: '無料で始めて、必要な時にスケール。',
      sectionDesc: '全ツールが無料プランに含まれています。自分のAPIキーを持ち込んで、すぐに投稿開始。',
      free: {
        name: 'Free',
        price: '$0',
        period: '/永久',
        desc: '自分のAPIキーを使用',
        f1: '全9つのAIツール',
        f2: '無制限の生成',
        f3: 'スタイル＆ボイスクローン',
        f4: 'ツイートスコアリング＆分析',
        f5: '自分のAPIキーを使用',
        cta: '始める',
      },
    },
    mock: {
      input: 'バズるツイートって結局シャワー中の思いつきなんだよな。計画したコンテンツでもスレッドでもない — ふと浮かんだ一言が刺さる...',
      tweet1: 'バズるツイートはもう頭の中にある。深夜2時にぼそっと呟くやつ、あれが正解。',
      tweet2: 'コンテンツを計画するな。思いつきを捕まえろ。アルゴリズムが報いるのは戦略じゃなくて本音。',
    },
    ctaTitle: '考えすぎるのはやめよう。',
    ctaDesc: 'AI搭載ツイートで毎週何時間も節約しているクリエイターの仲間入り。',
    ctaButton: '無料で始める',
    ctaHint: 'クレジットカード不要。自分のAPIキーを使用。',
    footer: '\u00A9 2026 Bangerfy. All rights reserved.',
  },

  loginPage: {
    appDescription: 'AIでツイートを生成・最適化',
    signInWithGoogle: 'Googleでログイン',
    email: 'メールアドレス',
    password: 'パスワード（6文字以上）',
    loginButton: 'ログイン',
    signupButton: 'アカウント作成',
    enterEmailAndPassword: 'メールアドレスとパスワードを入力してください',
    passwordTooShort: 'パスワードは6文字以上必要です',
    confirmationSent: '確認メールを送信しました',
    confirmationDesc: '{{email}} に確認メールを送信しました。メール内のリンクをクリックしてアカウントを有効化してください。',
    backToLogin: 'ログイン画面に戻る',
    noAccount: 'アカウントをお持ちでない方は',
    hasAccount: '既にアカウントをお持ちの方は',
    signUp: '新規登録',
    logIn: 'ログイン',
  },

  authCallback: {
    authenticating: '認証中...',
    pleaseWait: '少々お待ちください',
    authSuccess: '認証成功',
    navigatingHome: 'ホーム画面に移動します...',
    authFailed: '認証失敗',
    authCodeNotFound: '認証コードが見つかりません',
  },

  brainDump: {
    title: 'Brain Dump',
    subtitle: '思いつきをそのまま書き出して、ツイートに仕上げる',
    countLabel: '生成数:',
    recommended: '(推奨)',
    showAllLabel: '全表示（オフ: 多様性Top 5）',
    hideSettings: '設定を隠す',
    advanced: '詳細設定',
    placeholder: '頭の中にあることを書いてみよう...\n\n例:\n- 今日学んだこと\n- 気になっているテーマ\n- 伝えたいメッセージ\n- ふと浮かんだアイデア',
    generateTweets: 'ツイート生成',
    strategyButton: '戦略（通常+ティーザー+ノート宣伝+スレッド）',
    strategyDesc: '7段階思考 → 通常投稿+ティーザー/回答ペア+ノート宣伝3パターンを一括生成',
    generatingCandidates: '候補を生成中...',
    strategyGenerating: '戦略を生成中...',
    progressDesc: 'テンプレート生成 → スコアリング → 多様性チェック中',
    strategyProgressDesc: '7段階思考を通常・ティーザー・ノート宣伝・スレッドに展開中',
    errorHints: {
      api: 'APIキー・モデル設定を確認',
      input: '入力テキストを短くしてみる',
      wait: '数秒待ってからリトライ',
    },
    results: '生成されたツイート（全{{count}}件）',
    edit: '編集',
    saveToIdeas: 'アイデアに保存',
    hideScoreDetails: 'スコア詳細を隠す',
    showScoreDetails: 'スコア詳細を見る',
    freshness: '新鮮さ',
    specificity: '具体性',
    personaFit: 'ペルソナ適合',
    replyHook: 'リプライフック',
    strategySet: '戦略セット',
    strategyLabel: 'ティーザー→回答 / ノート宣伝 / スレッド',
    standardTweet: '通常ツイート',
    shortThread: 'ショートスレッド（3投稿）',
    teaserAnswer: 'ティーザー → 回答',
    teaserLabel: '投稿1 / ティーザー',
    answerLabel: '投稿2 / 回答',
    notePromo: 'ノート宣伝 3パターン',
    showThoughtLog: '思考ログを表示',
    hideThoughtLog: '思考ログを隠す',
    voiceInput: '音声入力',
    stopRecording: '録音停止',
    transcribing: '文字起こし中...',
    voiceAdded: '音声入力を追加しました',
  },

  tweetSettings: {
    title: 'ツイート戦略',
    description: '長さ・トーン・スタイルを先に決めて、生成結果を安定させます',
    reset: 'リセット',
    lengthLabel: '長さ',
    lengthHint: '280文字以内で最適化',
    toneLabel: 'トーン',
    styleLabel: 'スタイル',
    humanizeLabel: 'AI臭さ除去レベル',
    humanizeDesc: 'Lv1: 標準 / Lv3: 少し崩す / Lv5: 人間っぽさ最優先（冗長さ・ゆらぎOK）',
    length: {
      short: '短文',
      shortHelper: '〜60文字・即結論',
      medium: '中文',
      mediumHelper: '100-140文字・読み切り',
      long: '長文',
      longHelper: '200文字〜・深掘り',
    },
    tone: {
      oneLiner: '一言型',
      oneLinerHelper: '結論だけを鋭く',
      explanatory: '説明型',
      explanatoryHelper: '理由や背景をセット',
      story: 'ストーリー型',
      storyHelper: '起承転結で語る',
    },
    style: {
      assertive: '断言系',
      assertiveHelper: '言い切り・強め',
      empathetic: '共感系',
      empatheticHelper: '寄り添い・柔らかめ',
      warning: '警告系',
      warningHelper: '注意喚起・リスク提示',
      secret: 'こっそり系',
      secretHelper: '内緒話・オフレコ風',
    },
  },

  quickActions: {
    toggle: 'クイックテンプレート',
    learning: '今日学んだこと',
    learningTemplate: '今日学んだこと:\n\n',
    learningDesc: '学びをシェア',
    tips: 'ライフハック',
    tipsTemplate: '便利な小技を発見！\n\n',
    tipsDesc: 'Tipsを共有',
    opinion: '意見・考察',
    opinionTemplate: '最近考えていること:\n\n',
    opinionDesc: '考えをまとめる',
    question: '質問・疑問',
    questionTemplate: 'みんなに聞きたいんだけど、\n\n',
    questionDesc: '意見を募る',
    experience: '体験談',
    experienceTemplate: '最近こんな体験をした:\n\n',
    experienceDesc: 'エピソード共有',
    thread: 'スレッド',
    threadTemplate: 'スレッドで詳しく解説します\uD83D\uDC47\n\n1. ',
    threadDesc: '長文をスレッド化',
  },

  composeIdeas: {
    title: 'アイデア構成',
    subtitle: 'アイデアブロックからツイートを組み立て、バリエーションを生成',
    ideaBlocks: 'アイデアブロック',
    addBlock: '+ ブロック追加',
    blockLabel: 'ブロック {{n}}',
    blockPlaceholder: 'アイデア {{n}}...',
    combineBlocks: 'ブロックを結合 →',
    combinedTweet: '結合ツイート',
    combinedPlaceholder: '結合結果がここに表示されます...',
    generateVariations: 'バリエーション生成',
    variations: 'バリエーション',
    variationLabel: 'バリエーション #{{n}} — スコア: {{score}}',
  },

  contentCoach: {
    title: 'コンテンツコーチ',
    subtitle: '投稿前にAIフィードバックでツイートを磨く',
    inputLabel: 'ツイート下書き',
    placeholder: 'コーチングしたいツイートの下書きをペーストしてください...',
    coachingAreas: 'コーチング項目',
    areas: {
      hook: 'フック力',
      clarity: '明確さ',
      engagement: 'エンゲージメント',
      cta: 'アクション誘導',
      length: '長さチェック',
    },
    getCoaching: 'コーチングを受ける',
    results: 'コーチング結果',
    overall: '総合',
    suggestion: '提案',
    improved: '改善版',
    emptyState: '上にツイート下書きを入力し、\nコーチング項目を選んでフィードバックを受けましょう',
  },

  algoAnalyzer: {
    title: 'アルゴ分析',
    subtitle: '8つのアルゴリズム指標で投稿をスコアリング',
    inputLabel: '分析するコンテンツ',
    placeholder: 'ツイートをペーストしてください...\n\n例:\nプログラミングで一番大事なのは、完璧を目指さない勇気だと気づいた。動けばいい。リファクタリングは後でいい。',
    analyzePost: '投稿を分析',
    results: '分析結果',
    overallScore: '総合アルゴスコア',
    excellent: '素晴らしい！この投稿はアルゴリズムに高度に最適化されています',
    good: '良いコンテンツです。少し調整すればさらに良くなります',
    needsWork: '改善の余地があります。上のスコアが低い項目を確認してください',
    noResults: '分析結果を取得できませんでした',
    error: 'エラー',
    errorMessage: '分析に失敗しました。APIキーを確認してください。',
    metrics: {
      hookStrength: 'フック力',
      hookComment: 'スクロールを止める強い導入',
      clarity: '明確さ',
      clarityComment: '誤解の余地がないクリアなメッセージ',
      engagement: 'エンゲージメント力',
      engagementComment: 'いいねやRTを獲得しやすい要素を含む',
      curiosity: '好奇心ギャップ',
      curiosityComment: '続きを読みたくなる仕掛け',
      emotional: '感情インパクト',
      emotionalComment: '効果的な感情的表現',
      shareability: '共有性',
      shareabilityComment: '他人にシェアしたくなる内容',
      trendAlignment: 'トレンド適合',
      trendComment: '現在のトレンドとの関連性',
      readability: '可読性',
      readabilityComment: '読みやすい構造と言葉遣い',
    },
    systemPrompt: {
      instruction: '以下のツイート/投稿を8つの指標で分析し、JSONのみで回答してください。',
      contentLabel: '投稿内容:',
      metricsLabel: '分析指標（各0-10点）:',
      hookStrength: 'フックの強さ（最初の1行で注目を引けるか）',
      clarity: '明確さ（メッセージが伝わりやすいか）',
      engagement: 'エンゲージメント誘発力（いいね・RTされやすいか）',
      curiosity: '好奇心喚起（続きが読みたくなるか）',
      emotional: '感情訴求（共感・驚き・笑いを誘うか）',
      shareability: 'シェアしたくなるか',
      trendAlignment: 'トレンドとの親和性',
      readability: '読みやすさ（改行・長さ・リズム）',
      formatLabel: '出力形式:',
      systemMessage: 'あなたはX（Twitter）投稿の分析専門家です。指定のJSONフォーマットのみで回答してください。',
    },
  },

  replyGuy: {
    title: 'リプライガイ',
    subtitle: '会話に参加するための魅力的なリプライを作成',
    originalTweet: '元ツイート',
    placeholder: 'リプライしたいツイートをペーストしてください...',
    replyTone: 'リプライのトーン',
    tones: {
      empathy: '共感',
      empathyDesc: '理解と繋がりを示す',
      question: '質問',
      questionDesc: '会話を広げる',
      humor: 'ユーモア',
      humorDesc: 'ウィットを効かせる',
      expert: '専門家',
      expertDesc: '専門知識をシェア',
      casual: 'カジュアル',
      casualDesc: 'フレンドリーでリラックス',
    },
    generateReplies: 'リプライ生成',
    topReplies: 'トップ5リプライ',
    emptyState: '左にツイートを入力し、\nトーンを選んでリプライを生成しましょう',
  },

  inspiration: {
    title: 'インスピレーション',
    subtitle: 'ツイートアイデアとトレンドトピックを探す',
    trendingTopics: 'トレンドトピック',
    getTrends: 'トレンド取得',
    generateFromKeyword: 'キーワードからアイデア生成',
    keywordPlaceholder: 'キーワードを入力... (例: React, AI, 副業)',
    generate: '生成',
    ideasFor: '「{{keyword}}」のアイデア',
    savedInspirations: '保存されたインスピレーション',
    postsLabel: '{{count}}件の投稿',
    more: '...+{{count}}件',
  },

  accountResearcher: {
    title: 'アカウント分析',
    subtitle: '任意のアカウントの投稿を分析して成功パターンを学ぶ',
    postsToAnalyze: '分析する投稿',
    accountName: 'アカウント名（任意）',
    placeholder: '投稿を1行ずつペーストしてください...\n\n例:\nプログラミングで一番大事なのは完璧を目指さないこと\nエラーメッセージをちゃんと読めばほとんどの問題は解決する\n朝のコーディングは夜の3倍生産的',
    postsEntered: '{{count}}件の投稿を入力済み',
    runAnalysis: '分析を実行',
    commonPatterns: '共通パターン',
    toneAnalysis: 'トーン分析',
    topicBreakdown: 'トピック内訳',
    engagementTriggers: 'エンゲージメントトリガー',
    emptyState: '左に投稿を入力して\n分析を実行するとパターンが表示されます',
    pastAnalyses: '過去の分析',
    unnamed: '名前なし',
  },

  setupFlow: {
    title: '初回セットアップ',
    subtitle: 'あなた専用のAIツイート生成エンジンを構築します',
    fetching: {
      title: '過去ツイートを取得中...',
      desc: '直近500件のツイートを読み込んでいます',
    },
    analyzingStyle: {
      title: '文体を分析中...',
      desc: '{{count}}件のツイートから、あなたの文体を学習しています',
    },
    analyzingBuzz: {
      title: 'バズパターンを分析中...',
      desc: 'エンゲージメントの高いツイートから成功要因を抽出しています',
    },
    complete: {
      title: 'セットアップ完了！',
      tweetsAnalyzed: '{{count}}件のツイートを分析しました',
      styleModel: '文体モデルを作成しました',
      buzzPatterns: 'バズパターンを抽出しました',
      startButton: '始める →',
      buzzTitle: 'あなたのバズパターン',
    },
    error: {
      title: 'エラーが発生しました',
      commonCauses: 'よくあるエラー原因:',
      invalidKey: 'OpenAI API Keyが無効',
      networkIssue: 'ネットワーク接続の問題',
      tooFewTweets: 'ツイート数が不足（最低10件必要）',
      retryButton: '再試行',
    },
    authError: '認証情報が見つかりません',
  },

  history: {
    title: '履歴',
    subtitle: '過去の生成・分析結果を検索・整理できます',
    exportCSV: 'CSVエクスポート',
    deleteAll: '全て削除',
    filters: {
      all: '全て',
      tweet: 'ツイート',
      analysis: '分析',
      coaching: 'コーチング',
      reply: 'リプライ',
      inspiration: 'インスピレーション',
      research: 'リサーチ',
    },
    searchPlaceholder: '内容・入力テキストで検索',
    dateRange: {
      all: '期間指定なし',
      day: '直近24時間',
      week: '直近7日',
      month: '直近30日',
    },
    sort: {
      newest: '新しい順',
      oldest: '古い順',
    },
    showing: '{{filtered}}件表示（全{{total}}件）',
    emptyState: '該当する履歴がありません。',
    emptyHint: 'フィルターを緩めて再検索してください。',
    emptyDefault: '生成・分析を行うとここに履歴が表示されます。',
  },

  rightSidebar: {
    savedIdeas: '保存アイデア ({{count}})',
    history: '履歴 ({{count}})',
    folders: 'フォルダ',
    newFolder: '+ 新規フォルダ',
    folderPlaceholder: 'フォルダ名',
    allIdeas: '全てのアイデア',
    emptyIdeas: '保存されたアイデアはありません。\n各機能の結果からブックマークボタンで保存できます。',
    emptyHistory: '履歴はまだありません。',
  },

  education: {
    title: '学習',
    subtitle: '効果的な使い方や学習教材を提供します',
    progress: '学習進捗',
    categories: 'カテゴリ',
    completed: '{{done}}/{{total}} 完了',
    codeExample: 'コード例',
    markAsRead: '読了にする',
  },

  admin: {
    title: '設定',
    subtitle: 'APIキーや各種設定を管理します',
    authMode: '認証モード',
    byok: '自分のAPIキー',
    byokDesc: '各プロバイダーのAPIキーを直接入力。従量課金で利用。',
    subscription: 'サブスクリプション',
    subscriptionPreparing: '準備中',
    subscriptionDesc: '月額プランでキー不要。全プロバイダーを定額利用。',
    subscriptionComingSoon: '近日公開予定。現在はBYOK（自分のAPIキー）モードをご利用ください。',
    subscriptionTitle: 'サブスクリプション',
    subscriptionFullDesc: '月額プランで全AI機能をキー不要で利用できます。',
    activeProvider: '使用するAIプロバイダー',
    configured: '設定済み',
    notConfigured: '未設定',
    providerNote: 'プロバイダーごとに別々のAPIキーを設定できます。文章生成には選択中のプロバイダーが使用されます。',
    howItWorks: '仕組み',
    howStep1: 'APIキーはブラウザ内でのみ保持され、サーバーに保存されません',
    howStep2: 'リクエスト時にキーがサーバーに送信され、各プロバイダーのAPIへ転送されます',
    howStep3: 'サーバーはキーを転送するだけで、ログや保存は一切行いません',
    inUse: '使用中',
    textGeneration: '文章生成',
    speechRecognition: '音声認識',
    loggedIn: 'ログイン済み',
    apiKey: 'APIキー',
    googleAccount: 'Googleアカウント',
    googleLoginFailed: 'ログインに失敗しました',
    enterApiKey: 'APIキーを入力してください',
    invalidKeyFormat: '無効な形式です。{{name}}のAPIキーは "{{prefix}}" で始まります。',
    logout: 'ログアウト',
    loggingIn: 'ログイン中...',
    loginWithGoogle: 'Googleアカウントでログイン',
    googleAiPremiumDesc: 'Google One AI Premium（Gemini Advanced）のサブスクリプションがあれば、APIキーなしでGeminiを利用できます。',
    googleClientIdMissing: 'Google Client ID が未設定',
    googleClientIdDesc: 'Googleログインを使用するには、Google Cloud ConsoleでOAuth Client IDを作成し、環境変数 REACT_APP_GOOGLE_CLIENT_ID に設定してください。',
    storagePersistent: 'ローカルストレージ（永続）',
    storageSession: 'セッション（タブを閉じると消去）',
    storageLabel: '保存先:',
    sessionOnly: 'セッションのみ',
    persistent: '永続保存',
    getKeyFrom: 'APIキーは',
    model: 'モデル',
  },

  settings: {
    title: 'AI設定',
    noApiKeysNeeded: 'APIキーはフロントエンドでは扱いません。',
    backendExplanation1: 'AI推論は安全なバックエンド（/api/generate, /api/transcribe）経由で実行されます。',
    backendExplanation2: '認証には REACT_APP_AUTH_TOKEN を使用し、ビルド時に埋め込まれます。',
    backendExplanation3: 'ブラウザにAPIキーを保存する必要はありません。',
    envVarTitle: '環境変数の設定',
    envVarDesc: 'プロジェクトの .env または Vercel の環境変数に REACT_APP_AUTH_TOKEN を設定してください。',
  },

  analytics: {
    subtitle: '投稿履歴を分析して、最適な投稿戦略を見つけましょう',
    importSuccess: '{{count}}件のツイートをインポートしました',
    importError: 'インポート失敗: {{error}}',
    confirmSample: 'サンプルデータ（50ツイート）を生成しますか？',
    confirmDelete: '全データを削除しますか？',
    empty: {
      subtitle: '投稿履歴を分析して、最適な投稿戦略を見つけましょう',
      message: 'データがありません。以下の方法でデータを追加してください：',
      importCsv: 'CSVファイルをインポート',
      generateSample: 'サンプルデータを生成（デモ用）',
    },
    csvFormat: 'CSV フォーマット例：',
    manage: 'データ管理',
    menu: {
      import: 'CSVインポート',
      sample: 'サンプル生成',
      deleteAll: '全削除',
    },
    tabs: {
      overview: '概要',
      topics: 'トピック',
      timing: 'タイミング',
      trends: 'トレンド',
    },
    insights: 'インサイト',
    metric: {
      totalTweets: '総ツイート数',
      avgLikes: '平均いいね',
      avgRt: '平均RT',
      avgReplies: '平均リプ',
    },
    best: 'ベストツイート',
    worst: '改善の余地あり',
    labels: {
      likes: 'いいね',
      rt: 'RT',
      replies: 'リプ',
      tweet: 'ツイート',
    },
    topics: {
      distribution: 'トピック分布',
      engagement: 'トピック別エンゲージメント',
    },
    timing: {
      heatmap: '投稿時間帯ヒートマップ',
      heatmapDesc: '色が濃いほどエンゲージメントが高い時間帯です',
      time: '時間',
      hour: '時',
      bestTitle: 'おすすめ投稿時間帯 Top 5',
      dayOfWeek: '曜日',
      postCount: '回投稿',
      avgEngagement: '平均エンゲージメント',
    },
    'days.0': '日', 'days.1': '月', 'days.2': '火', 'days.3': '水', 'days.4': '木', 'days.5': '金', 'days.6': '土',
    trends: {
      title: '過去30日間のトレンド',
      tweets: 'ツイート数',
      likes: 'いいね',
      retweets: 'リツイート',
      replies: 'リプライ',
    },
  },

  home: {
    subtitle: 'テキスト/音声からツイート案を瞬時に生成',
    settingsButton: '設定',
    input: {
      title: 'ツイート案を生成',
      subtitle: 'テキストまたは音声で入力してください',
      modeText: 'テキスト',
      modeVoice: '音声',
      placeholder: 'ツイートしたい内容を入力してください...',
    },
    button: {
      generate: 'ツイート案を生成',
      generateFromAudio: 'ツイート案を生成 →',
      reset: 'リセット',
      rerecord: '再録音',
      retry: 'もう一度試す',
      newGenerate: '新しく生成する',
      save: '保存',
    },
    audio: {
      recorded: '録音済み ({{size}} KB)',
    },
    tips: {
      title: 'コツ',
      tip1: '結論→理由→具体例の構成がスコア高め',
      tip2: '数字や固有名詞を入れると具体性スコアUP',
      tip3: '音声は静かな環境で録音すると精度UP',
    },
    permissions: {
      title: '権限チェック',
      description: 'マイク許可やAPI Keyは設定画面で確認できます。エラー時は一度リロードして再試行してください。',
    },
    status: {
      generating: 'ツイート候補を生成しています…',
      complete: '生成が完了しました。上位候補を表示しています。',
      compressing: '音声を圧縮して文字起こししています…',
      generatingAfterTranscribe: '文字起こし完了 → ツイート生成中…',
      analyzing: '音声を解析中... 文字起こし完了後に自動で生成を開始します。',
      refining: 'ツイート案を生成し、スコアリング＆多様性チェックを行っています。',
    },
    progress: {
      transcribing: '音声を文字起こし中…',
      generating: '生成＆スコアリング中…',
      complete: '完了',
      error: 'エラーが発生しました',
      idle: '待機中',
      label: '進捗',
    },
    error: {
      apiKey: 'API Key が未設定または無効です。設定画面から再設定してください。',
      network: 'ネットワークエラーです。接続を確認して再度お試しください。',
      parse: '生成結果の解析に失敗しました。少し時間をおいて再実行してください。',
      general: '処理に失敗しました',
      noAudio: '録音が見つかりません。もう一度録音してください。',
      helpApiKey: 'API Key とプロバイダ設定を確認',
      helpNetwork: 'ネットワークを再接続して再試行',
      helpAudio: '音声の場合は再録音してから実行',
    },
    transcription: {
      title: '文字起こし結果',
    },
    initial: {
      message: 'テキスト入力または録音を行い、「ツイート案を生成」を押してください。',
    },
    results: {
      title: 'ツイート案 Top',
    },
    breakdown: {
      freshness: '新規性',
      specificity: '具体性',
    },
    statusBadge: {
      complete: '完了',
      error: '要確認',
    },
    length: '長さ:',
  },

  drafts: {
    title: '下書き',
    subtitle: '生成したツイートを保存・管理します',
    exportImport: 'エクスポート / インポート',
    format: '形式:',
    jsonImport: 'JSONインポート',
    importSuccess: '{{count}}件の下書きをインポートしました',
    importError: 'インポート失敗: {{error}}',
    confirmDelete: 'この下書きを削除しますか？',
    search: '下書きを検索...',
    stats: {
      total: '合計',
      favorites: 'お気に入り',
      avgScore: '平均スコア',
      tags: 'タグ',
    },
    filter: {
      all: 'すべて',
      favorites: 'お気に入り',
    },
    sort: {
      newest: '新しい順',
      oldest: '古い順',
      scoreHigh: 'スコア高い順',
      scoreLow: 'スコア低い順',
    },
    tags: {
      all: 'すべてのタグ',
      add: '+ タグ追加',
    },
    empty: {
      search: '検索結果なし',
      default: '下書きがありません',
    },
    notesPlaceholder: 'メモ（任意）',
    created: '作成:',
  },

  scoreBreakdown: {
    totalScore: '総合スコア',
    improvementHints: '改善のヒント',
    feedback: {
      excellent: '非常に良い！バズる可能性高い',
      good: '良い！投稿してOK',
      needsWork: 'もう少し改善できるかも',
    },
    freshness: {
      label: '新規性',
      description: '過去のツイートとの類似度が低いほど高スコア',
      tips: { '0': '同じフックの繰り返しを避ける', '1': 'n-gram類似度で判定', '2': '既視感のあるフレーズにペナルティ' },
    },
    specificity: {
      label: '具体性',
      description: '固有名詞・数字・時間表現が多いほど高スコア',
      tips: { '0': '固有名詞を入れる（VSCode、スタバ等）', '1': '数字を使う（3回、5分、90%等）', '2': '時間表現（今日、昨日、さっき等）' },
    },
    personaFit: {
      label: '整合性',
      description: 'あなたの文体との一致度',
      tips: { '0': '絵文字の使用頻度が適切', '1': '文の長さが適切', '2': '改行の使い方が一致' },
    },
    replyHook: {
      label: '返信誘発',
      description: '返信したくなる要素の有無',
      tips: { '0': '質問形式を使う', '1': '共感を誘う表現', '2': '行動喚起（教えて、試して等）' },
    },
    readability: {
      label: '読みやすさ',
      description: '適切な長さ・改行・文字バランス',
      tips: { '0': '100-200字が理想的', '1': '改行は1-3回', '2': '一文は50字以下' },
    },
    risk: {
      label: 'リスク',
      description: '炎上リスク（低いほど良い）',
      tips: { '0': '過激な表現を避ける', '1': '政治・宗教・差別に注意', '2': 'デマ・個人情報に注意' },
    },
  },

  weightAdjuster: {
    title: 'スコアリング重み',
    description: 'スコア計算の重みを調整',
    customWeights: 'カスタム重み',
    defaultWeights: 'デフォルト重み',
    resetButton: 'リセット',
    totalLabel: '合計: {{total}} / 1.00',
    normalizationNote: '（正規化されます）',
    presetsSection: 'プリセット',
    presets: {
      buzz: { title: 'バズ重視', description: '新規性・具体性を優先' },
      style: { title: '文体重視', description: '整合性を最優先' },
      engagement: { title: '交流重視', description: '返信誘発を最優先' },
      safety: { title: '安全重視', description: 'リスク回避を最優先' },
    },
    metrics: {
      freshness: { label: '新規性', description: '過去のツイートとの類似度が低いほど高スコア' },
      specificity: { label: '具体性', description: '固有名詞・数字・時間表現が多いほど高スコア' },
      personaFit: { label: '整合性', description: 'あなたの文体との一致度' },
      replyHook: { label: '返信誘発', description: '返信したくなる要素（質問・共感・CTA等）' },
      readability: { label: '読みやすさ', description: '適切な長さ・改行・文字バランス' },
      risk: { label: 'リスク', description: '炎上リスク（低いほど良い・マイナス重み）' },
    },
  },

  voiceRecorder: {
    errors: {
      notSupported: 'お使いのブラウザでは録音がサポートされていません。別のブラウザをお試しください。',
      recordingFailed: '録音中にエラーが発生しました。もう一度お試しください。',
      startFailed: '録音を開始できませんでした。別のアプリがマイクを使用していないか確認してください。',
      accessDenied: 'マイクへのアクセスが拒否されました。ブラウザの権限設定から許可してください。',
      notFound: 'マイクデバイスが見つかりません。接続や設定を確認してください。',
      notReadable: 'マイクを利用できません。他のアプリで使用されている可能性があります。',
    },
    status: {
      requestingPermission: 'マイクの許可をリクエスト中...',
      recording: '録音中',
      permissionDenied: 'マイク権限がありません',
      ready: 'マイク準備完了',
      idle: '待機中',
    },
    requesting: '許可を求めています',
    info: {
      maxDuration: '最大 {{maxDuration}} 秒まで録音できます。録音後は自動で保存されます。',
      remaining: '残り {{remaining}} 秒 · 再度タップで停止',
      recordingTap: '録音中... タップで停止',
      startTap: 'タップして録音開始',
    },
    permission: {
      required: '権限を許可してください',
    },
    aria: {
      stop: '録音を停止',
      start: '録音を開始',
    },
  },

  errorBoundary: {
    clearDataConfirm: 'すべてのローカルデータをクリアしてリセットしますか？\n（文体・バズ分析データも削除されます）',
    title: 'エラーが発生しました',
    message: '申し訳ございません。アプリで問題が発生しました。',
    unexpectedError: '予期しないエラーが発生しました',
    developerInfo: '詳細情報（開発者向け）',
    retryButton: '再試行',
    reloadButton: 'ページをリロード',
    clearDataButton: 'データをクリアしてリセット',
    solutionTitle: '解決方法:',
    solution1: '「再試行」で一時的な問題が解決することがあります',
    solution2: '「ページをリロード」でアプリを再起動します',
    solution3: '問題が続く場合は「データをクリア」をお試しください',
  },

  archiveUpload: {
    title: 'Twitter Archive をアップロード',
    invalidFile: 'ファイル形式が正しくありません。tweets.js をアップロードしてください。',
    notEnoughTweets: 'ツイートが少なすぎます（最低10件必要）',
    uploadFailed: 'アップロードに失敗しました',
    dragDrop: '<strong>tweets.js</strong> をドラッグ＆ドロップ',
    orClickToSelect: 'または クリックしてファイルを選択',
    howToGet: 'Twitter Archive の取得方法',
    step1: 'から「全ツイート履歴」をリクエスト',
    step2: '24時間後にダウンロード可能（メール通知が来る）',
    step3: 'ZIPを解凍 → <code>data/tweets.js</code> をアップロード',
    tryDemo: 'デモで試す（API key不要・即体験）',
    skipWithApiKey: 'スキップ（Twitter API keyを使う）',
  },

  stats: {
    title: '統計情報',
    notSet: '未設定',
    totalGenerated: '生成したツイート数',
    cumulative: '累計',
    avgScore: '平均スコア',
    qualityIndicator: '品質指標',
    bestScore: '最高スコア',
    best: 'ベスト',
    styleAnalysis: '文体分析',
    lastUpdated: '最終更新',
    buzzAnalysis: 'バズ分析',
    setupStatus: 'セットアップ状況',
    setupComplete: '完了',
    setupIncomplete: '未完了',
    readyMessage: '準備OK',
    setupNeeded: 'セットアップが必要',
    tip: 'Tip: 文体・バズ分析を定期的に更新すると、より精度の高いツイートを生成できます。',
  },

  templateSelector: {
    selectingCount: '型を選択中（{{count}}/{{max}}）',
    selectOptional: '型を選択（任意）',
    selectTitle: 'ツイートの型を選択（{{count}}/{{max}}）',
    random: 'ランダム',
    limit: '上限',
    pattern: 'パターン:',
    example: '例:',
  },

  tweetEditor: {
    title: 'ツイートを編集',
    emptyError: 'ツイートが空です',
    tooLongError: '280文字を超えています',
    placeholder: 'ツイート内容を編集...',
    tip: 'Tip: 改行、絵文字、数字を使うとエンゲージメントUP',
    strategySettings: 'ツイート戦略設定',
  },

  apiKeyPrompt: {
    title: 'OpenAI API Key が必要です',
    description: '文体分析・ツイート生成に OpenAI API（GPT-4o mini）を使用します。\nあなた自身のAPIキーを入力してください。',
    label: 'OpenAI API Key',
    getKeyInfo: 'APIキーは OpenAI Platform で取得できます',
    continueButton: '続ける',
  },

  comingSoon: {
    title: 'Coming Soon',
    underDevelopment: 'この機能は開発中です',
  },

  protectedRoute: {
    checking: '認証確認中...',
  },
} as const;
